var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorImg from '@images/marketing/Error404.jpg';
import { useMediaQuery } from '@mui/system';
import { HelmetProvider } from 'react-helmet-async';
import { AppProvider } from './AppContext';
import { AuthProvider } from './AuthContext';
import { TWMergeProvider } from './TWMergeContext';
import { ButtonLink } from './components/global/CTA/Button';
import ScallopedImage from './components/global/misc/ScallopedImage';
import { HeadingTag } from './components/global/typography/Heading/Heading';
import FlexSection from './components/sections/FlexSection';
import { RootContainer } from './layout';
var ErrorBoundary = function () {
    var isMobile = useMediaQuery('(max-width: 768px)');
    var imageHeight = isMobile ? 132 : 447;
    return (_jsx(HelmetProvider, { children: _jsx(AppProvider, { children: _jsx(AuthProvider, { children: _jsx(TWMergeProvider, { children: _jsx(RootContainer, { children: _jsxs(FlexSection, __assign({ backgroundColorStyle: "bg-surface-beige", paddingStyle: "px-2xs-gutter pt-sm-gutter pb-lg-gutter md:px-3xl-gutter md:pt-lg-gutter md:pb-xl-gutter", gapStyle: "gap-xl-m md:gap-3xl-gutter", className: "text-center md:text-left text-text-body items-center" }, { children: [_jsx("div", __assign({ className: "shrink-0" }, { children: _jsx(ScallopedImage, { size: isMobile ? 'small' : 'large', imgData: { src: ErrorImg, alt: 'Dog rolling around in the grass' }, height: imageHeight }) })), _jsxs("div", __assign({ className: "flex flex-col items-center md:items-start gap-xl-m md:gap-2xl-m" }, { children: [_jsx(HeadingTag, __assign({ as: "h1", size: "lg" }, { children: "Whoops - Page Not Found" })), _jsx("p", { children: "Try navigating somewhere else or clicking the button below to to go to the homepage." }), _jsx(ButtonLink, __assign({ use: "secondary", size: "large", href: "/", className: "w-full md:w-auto" }, { children: "Sit. Stay. Go Home." }))] }))] })) }) }) }) }) }));
};
export default ErrorBoundary;
